import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { PostsService } from '../shared/services/posts.service';
import { IPost } from '../shared/models/ipost';

@Component({
  selector: 'app-posts-list',
  templateUrl: './posts-list.component.html',
  styleUrls: ['./posts-list.component.scss']
})
export class PostsListComponent implements OnInit {
  @Input() amount: number;
  public posts: Array<IPost>;

  constructor(private _postsService: PostsService) { }

  ngOnInit() {
    this.getPosts(this.amount);

    window.addEventListener('resize', ev => {
      this.resizePosts();
    });
  }

  getPosts(amount: number) {
    this._postsService.getPosts(amount).subscribe(
      data => { this.posts = data; },
      err => console.error(err),
      () => this.resizePosts()
    );
  }

  resizePosts() {
    window.setTimeout(
      () => {
        const postsElements = document.querySelectorAll('.post');
        if (postsElements) {
          let maxHeight = 0;

          [].forEach.call(postsElements, (post) => {
            post.querySelector('.mat-card-header').style.height = `auto`;
          });

          [].forEach.call(postsElements, (post) => {
            const h = post.querySelector('.mat-card-header').clientHeight;
            if (h > maxHeight) {
              maxHeight = h;
            }
          });

          if (window.innerWidth >= 480) {
            [].forEach.call(postsElements, (post) => {
              post.querySelector('.mat-card-header').style.height = `${maxHeight}px`;
            });
          }
        }
      },
      375
    );
  }

}



// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/posts/posts-list/posts-list.component.ts